import { startOfDay, subDays } from "date-fns";
import type { AnalyticsDateRange, AnalyticsPreset } from "./types";

type AnalyticsPresetConfig = {
  label: string;
  getRange: () => AnalyticsDateRange;
};

export const REQUEST_CANCEL_VISIBILITY_DELAY_MS = 3000;

export const ANALYTICS_PRESET_CONFIG: Record<
  AnalyticsPreset,
  AnalyticsPresetConfig
> = {
  today: {
    label: "Today",
    getRange: () => {
      const startDate = startOfDay(new Date());

      return { startDate, endDate: startDate };
    },
  },
  last7Days: {
    label: "Last 7 days",
    getRange: () => {
      const today = startOfDay(new Date());
      const startDate = subDays(today, 6);
      const endDate = today;

      return { startDate, endDate };
    },
  },
};
